import * as Telecom from '@servicetitan/telecom-rtcs-client';
import setQueueStatus from './setQueueStatus';
import getQueue from '../../lib/getQueue';
import log from '../../lib/log';
import refreshQueues from '../../lib/refreshQueues';
import featureFlagModule, { FeatureFlagKeys } from '@modules/FeatureFlagModule';

async function handleQueueSessionJoin(event: Telecom.QueueSessionJoinedEvent) {
  const queue = getQueue(event.queueId);

  log('rtcs:queue:session_join:' + queue?.name, event);

  if (!queue) {
    await refreshQueues();
    return;
  }

  if (
    featureFlagModule.isEnabled(FeatureFlagKeys.featureShowQueueLongestWaitTime)
  ) {
    queue.sessions = [
      ...(queue.sessions || []),
      {
        id: event.conversationId,
        position: event.joinedAtPosition,
        name: event.source.displayName ?? event.source.address,
        enteredAt: new Date(event.joinedAtTime),
      },
    ].sort((a, b) => a.enteredAt.getTime() - b.enteredAt.getTime());
  } else {
    queue.sessions = [
      ...(queue.sessions || []),
      {
        id: event.conversationId,
        position: event.joinedAtPosition,
        name: event.source.displayName ?? event.source.address,
        enteredAt: new Date(event.joinedAtTime),
      },
    ];
  }

  setQueueStatus(queue, event);
}

export default handleQueueSessionJoin;
